 import {observable, action, computed} from "mobx"
import axios from "axios"

class SortieStore{
  @observable rdv = {}
  @observable bien = {}
  @observable ordremission={}
  @observable sortie={}
  @observable pieces = []
  @observable dones = []
  @observable degats = []
  @observable showPDF = true
  constructor() {
    axios.get("/api/v1/experts/app/sortie/degats").then((data)=>{
      this.degats = data.data.degats
    })
  }
  @action setRdv(rdv){
    this.rdv = rdv
    this.loadPieces()
  }
  @computed get loaded(){
    if(this.rdv=={}){
      return false
    }else{
      return true
    }
  }
  @action loadPieces(){
    axios.post("/api/v1/experts/app/sortie/loadPieces",{id: this.rdv.id}).then((data)=>{
      this.pieces = data.data.pieces
      // this.dones = data.data.done
    })
  }


}

let store = new SortieStore()
global.SortieStore = store
export default store
